import { createVNode, render } from 'vue'
import Message from './message-component'

const div = document.createElement('div')
div.setAttribute('class', 'msssage-container')
document.body.appendChild(div)

let timer = null

export default ({ type, text }) => {
  const vnode = createVNode(Message, { type, text })
  render(vnode, div)
  clearTimeout(timer)
  timer = setTimeout(() => {
    render(null, div)
  }, 3000)
}
